var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.AppLayout,
    {
      attrs: {
        page: "/campaigns",
        backLink: _setup.activeCampaign?.id ? "/dashboard" : "/campaigns",
        pageTitle: "Automations",
      },
    },
    [
      [
        _c("v-card-title", { staticClass: "soli-grey py-0" }, [
          _vm._v(_vm._s(_vm.campaign.description)),
        ]),
      ],
      _vm._v(" "),
      _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c("v-data-iterator", {
            attrs: {
              items: _setup.filteredMessages,
              search: _setup.search,
              "group-by": "day_offset",
              "hide-default-footer": "",
              "disable-pagination": "",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex justify-start w-full mb-8 gap-4" },
                      [
                        _c("v-text-field", {
                          staticClass: "grow",
                          attrs: {
                            clearable: "",
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                            label: "Search",
                          },
                          model: {
                            value: _setup.search,
                            callback: function ($$v) {
                              _setup.search = $$v
                            },
                            expression: "search",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-select", {
                          staticClass: "shrink",
                          attrs: {
                            items: [null, ..._setup.channelOptions],
                            "item-text": (item) =>
                              item === null ? "All Channels" : item,
                            "item-value": (item) => item,
                            label: "Channel",
                            clearable: "",
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                          },
                          model: {
                            value: _setup.selectedChannel,
                            callback: function ($$v) {
                              _setup.selectedChannel = $$v
                            },
                            expression: "selectedChannel",
                          },
                        }),
                        _vm._v(" "),
                        _c("v-select", {
                          staticClass: "shrink",
                          attrs: {
                            items: [null, ..._setup.dayOptions],
                            "item-text": (item) =>
                              item === null ? "All Days" : `Day ${item}`,
                            "item-value": (item) => item,
                            label: "Day",
                            clearable: "",
                            outlined: "",
                            dense: "",
                            "hide-details": "",
                          },
                          on: {
                            input: function ($event) {
                              return _setup.shouldSend()
                            },
                            "click:clear": function ($event) {
                              return _setup.clear()
                            },
                          },
                          model: {
                            value: _setup.selectedDay,
                            callback: function ($$v) {
                              _setup.selectedDay = $$v
                            },
                            expression: "selectedDay",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (props) {
                  return _vm._l(props.groupedItems, function (group, idx) {
                    return _c(
                      "div",
                      { key: idx },
                      [
                        _c("v-card-title", { class: { "mt-2": idx > 0 } }, [
                          _vm._v("Day " + _vm._s(group.name)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          _vm._l(group.items, function (message, i) {
                            return _c(
                              "v-col",
                              {
                                key: message.id,
                                attrs: {
                                  cols: "12",
                                  md: "4",
                                  lg: "4",
                                  xl: "3",
                                },
                              },
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "soli-round" },
                                  [
                                    _vm.is("Admin")
                                      ? _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "right-3 top-3 !absolute",
                                            attrs: {
                                              icon: "",
                                              small: "",
                                              color: "dark",
                                              href: `/admin/campaign-message/${message.id}/edit`,
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { small: "" } },
                                              [_vm._v("edit")]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "v-card-text",
                                      { staticClass: "flex flex-col gap-2" },
                                      [
                                        _c("strong", [
                                          _vm._v("Message # " + _vm._s(i + 1)),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex items-center gap-2",
                                          },
                                          [
                                            _c("strong", [_vm._v("Channel: ")]),
                                            _vm._v(" "),
                                            _c(
                                              "v-chip",
                                              {
                                                staticClass: "font-bold px-2",
                                                attrs: {
                                                  "x-small": "",
                                                  color:
                                                    message.channel === "email"
                                                      ? "accent"
                                                      : "secondary",
                                                },
                                              },
                                              [_vm._v(_vm._s(message.channel))]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("div", [
                                          _c("strong", [_vm._v("Subject: ")]),
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(message.subject) +
                                              "\n                                    "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        message.description
                                          ? _c("div", [
                                              _c("strong", [
                                                _vm._v("Description: "),
                                              ]),
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(message.description) +
                                                  "\n                                    "
                                              ),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _setup.activeCampaign?.id &&
                                        _setup.selectedDay &&
                                        !_setup.selectionLoading
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex items-center",
                                              },
                                              [
                                                _c("strong", [
                                                  _vm._v("Should Send: "),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-icon",
                                                  {
                                                    staticClass: "ml-2 mr-1",
                                                    attrs: {
                                                      small: "",
                                                      color: message.shouldSend
                                                        ? "success"
                                                        : "error",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        message.shouldSend
                                                          ? "check_circle"
                                                          : "block"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(
                                                  _vm._s(message.shouldSend) +
                                                    "\n                                    "
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-divider"),
                                    _vm._v(" "),
                                    !message.finalContent
                                      ? _c(
                                          "v-card-text",
                                          { staticClass: "px-0" },
                                          [
                                            _c(
                                              "strong",
                                              { staticClass: "px-4" },
                                              [_vm._v("Content")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-expansion-panels",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  accordion: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-expansion-panel",
                                                  [
                                                    _c(
                                                      "v-expansion-panel-header",
                                                      [_vm._v("Primary")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-expansion-panel-content",
                                                      [
                                                        _c(
                                                          _setup.TipTapReader,
                                                          {
                                                            attrs: {
                                                              value:
                                                                message.content,
                                                            },
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                message.alt_content
                                                  ? _c(
                                                      "v-expansion-panel",
                                                      [
                                                        _c(
                                                          "v-expansion-panel-header",
                                                          [
                                                            _vm._v(
                                                              "Alternative"
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "v-expansion-panel-content",
                                                          [
                                                            _c(
                                                              _setup.TipTapReader,
                                                              {
                                                                attrs: {
                                                                  value:
                                                                    message.content,
                                                                },
                                                              }
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-card-text",
                                          [
                                            _c("strong", [_vm._v("Content")]),
                                            _vm._v(" "),
                                            _c(_setup.TipTapReader, {
                                              attrs: {
                                                value: message.finalContent,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                    _vm._v(" "),
                                    message.conditions
                                      ? _c("v-divider")
                                      : _vm._e(),
                                    _vm._v(" "),
                                    message.conditions
                                      ? _c(
                                          "v-card-text",
                                          { staticClass: "px-0" },
                                          [
                                            _c(
                                              "strong",
                                              { staticClass: "px-4" },
                                              [_vm._v("Workflow Logic")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-expansion-panels",
                                              { attrs: { flat: "" } },
                                              _vm._l(
                                                message.conditions,
                                                function (condition, idx) {
                                                  return _c(
                                                    "v-expansion-panel",
                                                    { key: idx },
                                                    [
                                                      _c(
                                                        "v-expansion-panel-header",
                                                        [
                                                          _vm._v(
                                                            "Condition\n                                                " +
                                                              _vm._s(idx + 1)
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-expansion-panel-content",
                                                        [
                                                          _c("p", [
                                                            _c("strong", [
                                                              _vm._v("Field: "),
                                                            ]),
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  condition.field
                                                                ) +
                                                                "\n                                                "
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Operator:\n                                                    "
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  condition.operator
                                                                ) +
                                                                "\n                                                "
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _c("strong", [
                                                              _vm._v("Value: "),
                                                            ]),
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  condition.value
                                                                ) +
                                                                "\n                                                "
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "onSuccess:\n                                                    "
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  condition.onSuccess
                                                                ) +
                                                                "\n                                                "
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "onFailure:\n                                                    "
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  condition.onFailure
                                                                ) +
                                                                "\n                                                "
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("p", [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "callbackData:\n                                                    "
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  condition.callbackData
                                                                ) +
                                                                "\n                                                "
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  })
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }